export * from './IconOdor';
export { default as IconOdor } from './IconOdor';
